import util from '@bmp-vue/core/api/util'
const controller = 'Wiwap'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get () {
    return [
      { prazo: 6, taxa: 2.90 },
      { prazo: 7, taxa: 3.40 },
      { prazo: 8, taxa: 3.40 },
      { prazo: 9, taxa: 3.40 },
      { prazo: 10, taxa: 3.80 },
      { prazo: 11, taxa: 3.80 },
      { prazo: 12, taxa: 3.80 },
      { prazo: 13, taxa: 4.30 },
      { prazo: 14, taxa: 4.30 },
      { prazo: 15, taxa: 4.30 },
      { prazo: 16, taxa: 4.70 },
      { prazo: 17, taxa: 4.70 },
      { prazo: 18, taxa: 4.70 },
      { prazo: 19, taxa: 5.60 },
      { prazo: 20, taxa: 5.60 },
      { prazo: 21, taxa: 5.60 },
      { prazo: 22, taxa: 5.60 },
      { prazo: 23, taxa: 5.60 },
      { prazo: 24, taxa: 5.60 },
    ]
  },
  GetItem (prazo, valor) {
    if (prazo && valor) {
      const percTAC = ctrl.Get().find(p => p.prazo === prazo).taxa
      return (valor.toFixed(2) * (percTAC / 100))
    }
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
})

export default ctrl
